export enum DepotBookingAccessor {
  Index = 'index',
  Number = 'number',
  BookingType = 'bookingType',
  TransactionType = 'transactionType',
  Status = 'status',
  CreatedAt = 'createdAt',
  ExpirationDate = 'expirationDate',
}
